<template>
  <div class="staking-header">
    <div class="inner">
      <div class="inner-wrap">
        <h1 class="title"><span class="title-inner">$STEAM Earnings Manager</span></h1>
        <div class="inner-content">
          <div class="inner-btn">
            <a href="/">
              <span>
                <img src="@/assets/sf/image/steam/pancake.png">
              </span>
              Buy on Pancake Swap
            </a>            
          </div>
          <div class="inner-input">
              <div class="inner-value" v-if="$store.state.isLogin">
                <span class="id">{{ $store.state.userAccount.id | omittedText }}</span>
              </div>
            <input class="inner-value" v-else type="text" value="" placeholder="enter….0x00000000" @keydown.enter="addAddress($event)">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AppHeader',
    data() {
      return {
        isDetail: false
      }
    },
    methods: {
      addAddress(e) {
        this.$store.dispatch('addAddress', e.target.value);
      }
    },
    filters: {
      omittedText(text) {
        if (window.innerWidth <= 768) {
          return text.length > 10 ? text.slice(0, 20) + "…" : text;
        }else{
          return text;
        }
      }
    }    
  }
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/_variables.scss';

  .staking-header {
    background-color: var(--color_bg_parts);
    overflow: hidden;
    .title-inner {
      display: inline-block;
      background: $gradation-vertical;
      background-clip: text;
      color: transparent;
      line-height: 1.5;
    }
    .inner {
      margin: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: relative;
      &::after {
        content: "";
        background-image: url(/assets/sf/image/steam/bg-steam.png);
        background-repeat: no-repeat;
        background-size: contain;
        display: block;
        @include media(sp) {
          position: absolute;
          left: 50%;
          top: 50px;
          transform: translate(-50%,0);
        }
      }
    }
    @include media(pc) {
      padding: 0 80px;
      .inner {
        width: 1100px;
        height: 350px;

        &::after {
          position: absolute;
          right: -80px;
          bottom: 46px;
          width: 400px;
          height: 238px;
        }
      }
    }
    @include media(sp) {
      padding: 56px 20px 24px;
      .inner {
        &::after {
          margin: auto;
          margin: auto;
          width: 170px;
          height: 170px;
          padding-top: 0;
          background-position: center;
        }
      }
    }
  }
  .title {
    font-weight: 800;
    margin-bottom: 24px;
    @include media(pc) {
      font-size: 4.5rem;
    }
    @include media(sp) {
      text-align: center;
      font-size: 2.3rem;
    }
  }
  .inner-wrap{
    width: fit-content;
    @include media(sp) {
      width: 100%;
    }
    .inner-content{
        @include media(sp) {
        margin-top: 200px;
        text-align: center;
        }
    }
    .inner-btn {
      height: 52px;
      margin-bottom: 20px;
      a{
        background: $gradation-vertical;
        padding: 10px 18px;
        border-radius: 8px;
        color: #fff;
        font-weight: 400;
        font-size: 1.3rem;
        &:hover{
          text-decoration: none;
        }
        span{
          margin-right: 10px;
        }
        img{
          vertical-align: text-bottom;
          width: 18px;
        }
      }
    }
    .inner-input{
      position: relative;
      &::after {
        content: "";
        position: absolute;
        top: 50%;
        left: 20px;
        transform: translate(0,-50%);
        background-image: url(/assets/sf/image/steam/wallet-icon.png);
        background-repeat: no-repeat;
        background-size: contain;
        display: block;
        width: 30px;
        height: 24px;        
      }        
      .inner-value{
        box-shadow: 0 0 10px #ccc;
        border-radius: 15px;
        padding: 18px 26px 18px 70px;
        width: 100%;
        font-size: 14px;
        position: relative; 
        text-align: left;
        background: #fff;
        color: #000;
        span{
          color: #000;
        }
      } 
    }
  }

</style>